import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { config } from './../../../config/index';

import { ContractCallbackService } from './contract-callback.service';
import { SessionStorageService } from '../shared/services/session-storage.service';
import { SnackbarService } from "../shared/services/snackbar.service";

@Component({
    template: require('./contract-callback.component.html'),
    styles: [require('./contract-callback.component.less')],
    providers: [ContractCallbackService, SnackbarService],
    preserveWhitespaces: true
})

export class ContractCallback implements OnInit {
    id: any;
    subscriptionPurpose: string;
    apiSubscription: Subscription;


    constructor(
        private _router: Router,
        private _sessionStorageService: SessionStorageService,
        private _contractCallbackService: ContractCallbackService,
        private _activatedRoute: ActivatedRoute,
        private _mdlSnackbarService: SnackbarService,
    ) {

    }
    ngOnInit() {
        this._sessionStorageService.readItem('subscription_purpose').then(
            (data) => {
                if(data === 'new') {
                    this.subscriptionPurpose = "YOUR_SUBSCRIPTION";
                }
            }
        );
        this._activatedRoute.params.subscribe(params => {
            this.id = params['id'];
        });
        this._activatedRoute.queryParams.subscribe(queryParams => {
            let event = queryParams['event'];
            if (event === 'signing_complete') {
                this.apiSubscription = this._contractCallbackService.sendDocuSignAuth({}, this.id).
                    subscribe(res => this.docusignSuccessHandler(res, event),
                    error => this.docusignErrorHandler(error));
            } else {
                this._router.navigate(['home/dashboard']);
            }
        });
    }

    // on docusign success
    docusignSuccessHandler(res: any, event: any) {
        // navigate to cart after updating subscription status to initial_pending
        this._sessionStorageService.readItem(config.role)
            .then((response: any) => {
                response.subscription_status = 'initial_pending';
                this._sessionStorageService.saveItem(config.role, response).then(() => {
                    this._router.navigate(['cart']);
                });
            }
        );
    }

    // on docusign failure
    docusignErrorHandler(error: any) {
        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
        this._router.navigate(['cart']);
    }

    ngOnDestroy() {
        this.apiSubscription?.unsubscribe();
    }

}